__turbopack_context__.v({
  "bar": "meal-plan-glance-module__RlHSgW__bar",
  "blank": "meal-plan-glance-module__RlHSgW__blank",
  "blankicon": "meal-plan-glance-module__RlHSgW__blankicon",
  "blanktext": "meal-plan-glance-module__RlHSgW__blanktext",
  "blanktitle": "meal-plan-glance-module__RlHSgW__blanktitle",
  "col": "meal-plan-glance-module__RlHSgW__col",
  "colShop": "meal-plan-glance-module__RlHSgW__colShop",
  "day": "meal-plan-glance-module__RlHSgW__day",
  "dayLink": "meal-plan-glance-module__RlHSgW__dayLink",
  "daylabel": "meal-plan-glance-module__RlHSgW__daylabel",
  "days": "meal-plan-glance-module__RlHSgW__days",
  "dishname": "meal-plan-glance-module__RlHSgW__dishname",
  "dishtime": "meal-plan-glance-module__RlHSgW__dishtime",
  "dishwrap": "meal-plan-glance-module__RlHSgW__dishwrap",
  "emptyCompact": "meal-plan-glance-module__RlHSgW__emptyCompact",
  "emptyCompactGo": "meal-plan-glance-module__RlHSgW__emptyCompactGo",
  "emptyCompactText": "meal-plan-glance-module__RlHSgW__emptyCompactText",
  "eyebrow": "meal-plan-glance-module__RlHSgW__eyebrow",
  "glance": "meal-plan-glance-module__RlHSgW__glance",
  "go": "meal-plan-glance-module__RlHSgW__go",
  "head": "meal-plan-glance-module__RlHSgW__head",
  "isEmpty": "meal-plan-glance-module__RlHSgW__isEmpty",
  "isToday": "meal-plan-glance-module__RlHSgW__isToday",
  "item": "meal-plan-glance-module__RlHSgW__item",
  "itemMore": "meal-plan-glance-module__RlHSgW__itemMore",
  "itemdot": "meal-plan-glance-module__RlHSgW__itemdot",
  "itemname": "meal-plan-glance-module__RlHSgW__itemname",
  "link": "meal-plan-glance-module__RlHSgW__link",
  "list": "meal-plan-glance-module__RlHSgW__list",
  "moreitem": "meal-plan-glance-module__RlHSgW__moreitem",
  "shopstats": "meal-plan-glance-module__RlHSgW__shopstats",
  "stat": "meal-plan-glance-module__RlHSgW__stat",
  "statMuted": "meal-plan-glance-module__RlHSgW__statMuted",
  "statdot": "meal-plan-glance-module__RlHSgW__statdot",
  "thumb": "meal-plan-glance-module__RlHSgW__thumb",
  "thumbFallback": "meal-plan-glance-module__RlHSgW__thumbFallback",
  "thumbImg": "meal-plan-glance-module__RlHSgW__thumbImg",
  "vchip": "meal-plan-glance-module__RlHSgW__vchip",
});
